import { OptionProps } from '@order/steps/templates/Default/Option/OptionDefault'
import PackageAttributesTile from '@order/PackageAttributes'
import { resolveTier } from '@order/steps/helpers'
import useStepOptionTranslations from '@order/steps/useStepOptionTranslations'
import { AnimatedRef } from 'react-native-reanimated'
import { View } from 'react-native'

interface Props extends OptionProps {
  onAttributePress?: (index: number) => void
  tileRef?: AnimatedRef<View>
  onLayout?: () => void
}

export default function OptionPackagesAttributes(props: Props) {
  const {
    title,
    lookup,
    price,
    value,
    isRecommended,
    attributes,
    onPress,
    onAttributePress,
    tileRef,
    onLayout,
  } = props

  const { discount, recommendedText } = useStepOptionTranslations({ lookup })

  return (
    <PackageAttributesTile
      tileRef={tileRef}
      title={title}
      tier={resolveTier(value)}
      attributes={attributes}
      price={price}
      onLayout={onLayout}
      discount={discount}
      isRecommended={isRecommended}
      recommendedText={recommendedText}
      onPress={onPress}
      onAttributePress={onAttributePress}
    />
  )
}
